import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  Button,
  Card,
  Container,
  Form,
  Grid,
  Header,
  Icon,
  Image,
  Loader,
  Message,
  Modal,
  Popup,
  Progress,
  Segment,
  Transition,
} from 'semantic-ui-react';
import * as Scroll from 'react-scroll';
import update from 'immutability-helper';
import XHRAsset from './xhr/asset.js';
import ColorSelection from './tool/ColorSelection.js';
import Options from './tool/Options.js';
import Utils from './Utils.js';

class Logo extends Component {
  constructor(props) {
    super(props);

    this.asset_type = this.props.match.params.asset;

    this.state = {
      username: '',
      theme: 'logo_generic',
      capacities: [],
      step: 1,
      logo_random_colors: true,
      creating: false,
      errors: {
        username: false,
        message: null,
      },

      // preview modal
      modal: { show: false, uid: null, thumb: null, },
    }
  }

  next = () => {
      switch (this.state.step) {
          case 0:
              this.setState({step: 1});
              break;
          default:
              return;
      }
  }

  create = () => {
   // validate the form
    let msg = this.validate();
    if (msg.length) {
      let e = this.state.errors;
      e.message = msg
      this.setState({
        errors: e,
      });
      return;
    }

    // remove displayed errors
    let e = this.state.errors;
    e.message = null;
    this.setState({
      errors: e,
      creating: true,
    });

    // xhr
    let ov = update(this.state, {$unset: ['creating', 'modal', 'errors', 'step']});
    XHRAsset.create('logo', ov).then((response) => {
      let modal = this.state.modal;
      modal.show = true;
      modal.thumb = response.thumb;
      modal.uid = response.uid;
      this.setState({
        modal: modal,
        creating: false,
      });
    }).catch((response) => {
      // TODO(remy): catch backend not available
      response.json().then((data) => {
        if (data.msg === 'bad parameter') {
          let e = this.state.errors;
          e.message = 'Please correctly fill the ' + data.param + ' field.';
          this.setState({
            creating: false,
            errors: e,
          });
        } else {
          let e = this.state.errors;
          e.message = 'An error occurred, please contact support@strmaker.com';
          this.setState({
            creating: false,
            errors: e,
          });
        }
      })
      console.log('error:', response);
    });
  }

  change = () => {
    let modal = this.state.modal;
    modal.show = false;
    this.setState({
      modal: modal,
    });
  }

  validate = () => {
    if (this.state.username.length === 0) {
        var err = this.state.errors;
        err.username = true;
        this.setState({
            errors: err,
        });
    }
    var msg = '';
    if (this.state.username.length === 0 || this.state.errors.username) {
      msg = 'Please enter some letters to represent your streamer name.';
    }
    return msg
  }

  preview = () => {
    return process.env.REACT_APP_API_DOMAIN + '/api/logo/' + this.state.modal.thumb + '.png';
  }

  onUsername = (event, data) => {
    this.setState({
      username: data.value,
    });
    if (data.value.length === 0) {
      let err = this.state.errors;
      err.username = true;
      this.setState({
        errors: err,
      });
    } else if (this.state.errors.username) {
      let err = this.state.errors;
      err.username = false;
      this.setState({
        errors: err,
      });
    }
  }

  render() {
    return (
      <Container>
        <Form>
         <Transition visible={true} animation='fade' duration={500}>
          <Grid columns={1} stackable>
            <Grid.Column>
              <Segment>
                <Header as='h2' textAlign='left'>
                  <Icon name='image outline'/>
                  <Header.Content>Select a theme</Header.Content>
                  <Header.Subheader>What kind of logo do you want to generate</Header.Subheader>
                </Header>
              </Segment>
            </Grid.Column>

            <Grid.Column>
              <Message color='orange'>
                <span style={{fontSize: '1.2em'}}><Icon name="info circle" />This feature is in beta, don't hesitate to send us any feedback to <a href='mailto:support@strmaker.com' style={{color: '#f2711c'}}>support@strmaker.com</a>!</span>
              </Message>
            </Grid.Column>

            <Grid.Column>
              <Form.Field>
                <Card.Group itemsPerRow={2}>
                  <Card key="random" centered>
                    <Card.Content>
                      <Card.Header>Fully random</Card.Header>
                      <Card.Description>Stream Maker will select random characteristics and will generate a custom random logo for you.</Card.Description>
                    </Card.Content>
                    <Card.Content extra>
                      <Form.Radio checked={true} />
                    </Card.Content>
                  </Card>

                  <Card key="diy" centered>
                    <Card.Content>
                      <Card.Header>Do It Yourself</Card.Header>
                      <Card.Description>You will select some characteristics manually, provide your username and Stream Maker will generate you variations for your custom logo.</Card.Description>
                    </Card.Content>
                    <Card.Content extra>
                       <Popup
                        trigger={<Form.Radio checked={false} />}
                        content='Not available during the BETA phase!'
                        size='large'
                      />
                    </Card.Content>
                  </Card>
                </Card.Group>
              </Form.Field>
              {this.state.step === 0 &&
                  <Form.Button primary onClick={this.next} fluid>Next</Form.Button>
              }
            </Grid.Column>

          { /* Step 2: username */ }

          <Transition visible={this.state.step >= 1} animation='fade' duration={500}>
          <Grid columns={1} stackable>
            <Grid.Column>
              <Segment>
                <Header as='h2' textAlign='left'>
                  <Icon name='user outline' />
                  <Header.Content>Letters</Header.Content>
                  <Header.Subheader>Please fill the letters / text / username that you want to draw on your logo. <br /><strong>We advise you to use between 1 and maximum 5 letters.</strong></Header.Subheader>
                </Header>
              </Segment>
            </Grid.Column>
            <Grid.Column>
              <Form.Field>
                <Form.Input maxLength={5} size='huge' focus={true} value={this.state.username} error={this.state.errors.username} onChange={this.onUsername} placeholder="1 to 5 letters" />
              </Form.Field>
              {this.state.step < 2 &&
                <Form.Button primary disabled={this.state.creating} loading={this.state.creating} onClick={this.create} fluid>Make!</Form.Button>
              }
            </Grid.Column>
          </Grid>
          </Transition>

          </Grid>
          </Transition>
        </Form>

        <Modal dimmer='blurring' closeOnEscape={true} size='fullscreen' onClose={this.change} open={this.state.modal.show} basic>
          <Header icon='thumbs outline up' content='Preview' />
          <Modal.Content>
            <h4>Preview of the logo generated with these settings</h4>
            {!this.state.creating &&
              <Image centered bordered src={this.preview()} style={{maxWidth: '100%'}} alt={"Preview of the generated "+this.asset_type} />
            }
            {this.state.creating &&
              <Loader>Generating...</Loader>
            }
          </Modal.Content>
          <Modal.Actions>
            <Button basic onClick={this.change} color='red' inverted>
              <Icon name='settings' /> Change settings
            </Button>
            <Button basic onClick={this.create} inverted>
              <Icon name='refresh' /> Regenerate
            </Button>
            <Link style={{marginLeft: '10px'}} to={'/preview/logo/' +this.state.modal.uid + '/' + this.state.modal.thumb}>
              <Button color='green'>
                <Icon name='thumbs outline up' /> Continue
              </Button>
            </Link>
          </Modal.Actions>
        </Modal>
      </Container>
    );
  }
}

export default Logo;


// WEBPACK FOOTER //
// ./src/Logo.js